import './App.css';
import Carousel from './components/Carousel';
import Home from './components/Home';
import NavBar from './components/NavBar';
import GoogleReviews from './components/GoogleReviews';
import Sobre from './components/Sobre';
import Mapa from './components/Mapa';
import Servicos from './components/Servicos';

function App() {
  return (
    <div className="App">
      <NavBar />
      <main className='body'>
        <section id="home">
          <Home />
        </section>
        <section id="sobre">
          <Sobre />
        </section>
        <section id="servicos">
          <Servicos />
        </section>
        <section id="estrutura">
          <Carousel />
        </section>
        <section id="reviews">
          <GoogleReviews />
        </section>
        <section id="mapa">
          <Mapa />
        </section>
      </main>
    </div>
  );
}



export default App;
